import { Component, OnInit, Input, EventEmitter, Output, Injector } from '@angular/core';
import * as x from 'world-archery-lib';
import { EventGeneralInfoItem, IFilterComboComponent } from 'world-archery-lib';
import { EventsResultsFiltersService } from '../../services/events-results-filters.service';
import { DrupalLangClass } from '../../../common-page-components/classes/drupal-lang-class';

@Component({
  selector: '[event-item]',
  templateUrl: './event-item.component.html',
  styleUrls: ['./event-item.component.scss'],
  inputs: ['event']
})
export class EventItemComponent extends DrupalLangClass {

  @Input() event: EventGeneralInfoItem;

  constructor(
    private filter_service: EventsResultsFiltersService,
    injector: Injector,
  ) {
    super(injector);

  }

  filterLevel(level: number) {
    if (this.filter_service.isWorldRankingSet != null) {
      this.filter_service.filtersType[2].options.options_selected_subject.next({ name: 'All' });
    } else {
      this.filter_service.filtersType[2].options.options_selected_subject.next({ name: 'Yes', value: 1 });
    }
  }

}
